import moment from 'moment';

const EmergencyContactsAdapter = (data) => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const getStatus = (i) => {
    if (i?.status === 'status_new') {
      if (moment().isAfter(moment(i?.date_from, 'YYYY-MM-DD'), 'day')) {
        return 'status_expired';
      } else {
        return 'status_new';
      }
    } else {
      return i?.status;
    }
  };

  const prepareData = (i) => ({
    ...i,
    'companies.title': i?.company?.title,
    created_at: moment(i?.created_at).format('DD/MM/YYYY HH:mm'),
    status: getStatus(i),
  });

  if (Array.isArray(data)) {
    data.forEach((i) => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};

export default EmergencyContactsAdapter;
